var VectorLayer     = require("./VectorLayer"),
    $               = require("jquery");

var defMarkerIcon = 'data:image/png;base64,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';

var MarkerLayer = VectorLayer.extend({

    options: {
        clustering: 40
    },

    initialize: function(options) {
        var that = this,
            group;

        options || (options = {});
        if ('group' in options) {
            group = options.group;
            delete options['group'];
        }

        MarkerLayer.__super__.initialize.call(that, options);

        that._defaultClusterStyle = new ol.style.Style({
            image: new ol.style.Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                opacity: 1,
                src: defMarkerIcon
            })
        });

        that.set('group', group);
    },

    _setup: function(){
        var that = this;

        that._olSource = new ol.source.Vector({
            features: []
        });

        that._olClusterSource = new ol.source.Cluster({
            distance: that.options['clustering'],
            source  : that._olSource
        });

        that._olLayer.setSource(that._olClusterSource);

        that._olLayer.setStyle(function(feature, resolution){
            return that._styler(feature, resolution);
        });
    },

    _styler: function(feature, resolution){
        var that = this,
            size = feature.get('features').length,
            styles = [];

        if (size > 1) {
            if (!that.get('clusterStyle')) {
                styles.push(that._defaultClusterStyle);
            } else {
                styles.push(that.get('clusterStyle'));
            }
        } else {
            styles.push(feature.get('features')[0].getStyle());
        }
        return styles;
    },

    addMarker: function(target, options){
        var that = this,
            iconStyle,
            marker,
            _options;

        options || (options = {});
        _options = $.extend(true, {}, options);

        if (target instanceof ol.Feature && target.getGeometry() instanceof ol.geom.Point) {
            that._olSource.addFeature(target);
            return;
        }

        if (!$.isArray(target)) {
            throw new Error("`coordinates` option is not Array ");
        }

        if ('style' in options) {
            iconStyle = options.style;
        } else {
            iconStyle = new ol.style.Style({
                image: new ol.style.Icon({
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    opacity: 1,
                    src: options.icon !== undefined ? options.icon : defMarkerIcon
                })
            });
        }

        _options.geometry = new ol.geom.Point(ol.proj.transform(target, 'EPSG:4326', 'EPSG:3857'));
        
        marker = new ol.Feature(_options);
        marker.setStyle(iconStyle);

        that._olSource.addFeature(marker);
        return marker
    },

    getMarkers: function(){
        var that = this;
        return that._olSource.getFeatures();
    },

    setClusterStyle: function(style){
        var that = this,
            _style = {
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                opacity: 1,
                src: ''
            };

        if (style instanceof ol.style.Style) {
            that.set('clusterStyle', style);
        } else if ($.isPlainObject(style)) {
            $.extend(true, _style, style);

            if ('icon' in _style) {
                _style.src = _style.icon;
                delete _style['icon'];
            }

            that.set('clusterStyle', new ol.style.Style({
                image: new ol.style.Icon(_style)
            }));
        }

        that._olLayer.setStyle(function(feature, resolution){
            return that._styler(feature, resolution);
        });

        return that;
    }
});

module.exports = MarkerLayer;


//////////////////
// WEBPACK FOOTER
// ./src/View/MarkerLayer.js
// module id = 236
// module chunks = 0